import { render, staticRenderFns } from "./scope_of_application.vue?vue&type=template&id=01c28396&scoped=true"
import script from "./scope_of_application.vue?vue&type=script&lang=js"
export * from "./scope_of_application.vue?vue&type=script&lang=js"
import style0 from "./scope_of_application.vue?vue&type=style&index=0&id=01c28396&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c28396",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01c28396')) {
      api.createRecord('01c28396', component.options)
    } else {
      api.reload('01c28396', component.options)
    }
    module.hot.accept("./scope_of_application.vue?vue&type=template&id=01c28396&scoped=true", function () {
      api.rerender('01c28396', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/point_manage/point_rule/components/scope_of_application.vue"
export default component.exports